<template>
  <div
    v-if="myPermissions[permission]"
    v-bind="$attrs"
  >
    <slot/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AuthButton',
  inheritAttrs: false,
  props: {
    permission: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('permission', [
      'myPermissions'
    ])
  }
}
</script>
